export enum CaseTypeFilterOptions {
    None = 1,
    Deleted = 2
}
